import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin } from 'react-icons/bs';


const SocialMedia = () => {
    return (
        <div className="app__social">
            <div>
                <a href="https://twitter.com/asymlar" target="_blank" rel="noreferrer">
                <BsTwitter />
                </a>
            </div>
            <div>
                <a href="https://www.instagram.com/aaliyahsymlar/" target="_blank" rel="noreferrer">
                <BsInstagram />
                </a>
            </div>
            <div>
                <a href="https://www.linkedin.com/in/aaliyah-symlar-931213102/" target="_blank" rel="noreferrer">
                <BsLinkedin />
                </a>
            </div>
        </div>
    )
}

export default SocialMedia;
